import { Box } from "@mui/material";
import niroggyan from "../assets/niroggyanWhite.png";
import { Link } from "react-router-dom";

const Navbar = ({ clientId }) => {
  let showLogo = clientId !== "NGCL0105";

  return (
    <Box
      sx={{
        backgroundColor: "#3567D6",
        padding: "12px 32px",
        width: "100%",
      }}
    >
      {showLogo ? (
        <Link to="/">
          <img src={niroggyan} alt="logo" height="30px" />
        </Link>
      ) : (
        <div style={{ height: "30px" }}></div>
      )}
    </Box>
  );
};

export default Navbar;
